import { ReactNode } from "react";
import ErrorPage from "../custom_components/ErrorPage";
import useError from "../hooks/useError";


interface ErrorProviderProps {
    children: ReactNode;
}
const ErrorProvider = ({ children }: ErrorProviderProps) => {
    const { error } = useError()

    return error ? <ErrorPage error={error} /> : children;
}

export default ErrorProvider